import React, { useEffect } from 'react';
import { BsTelephoneFill } from "react-icons/bs";
import { MdLocationPin, MdEmail } from "react-icons/md";
import logonew from '../Images/logonew.png';
import { useNavigate } from 'react-router-dom';
import { FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";

function ContactUs() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePhoneClick = () => {
    window.location.href = 'tel:04872695623';
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:vilvattamscb337@gmail.com';
  };

  const handleLocationClick = () => {
    window.open(
      'https://www.google.com/maps/place/Vilvattom+Service+Co-Operative+Bank+Ltd/@10.5472212,76.2241426,17z',
      '_blank'
    );
  };

  const handleWhatsappClick = () => {
    window.location.href = 'https://wa.me/918592345678'; // Replace with actual number
  };

  const handleInstagramClick = () => {
    window.location.href = 'https://www.instagram.com/'; // Replace with actual link
  };

  const handlefbClick = () => {
    window.location.href = 'https://www.facebook.com/profile.php?id=61563853036426'; // Replace with actual link
  };

  return (
    <div className='contact' style={{ backgroundColor: '#e74c3c', color: 'white' }}>
      <div className='main_contact_cont container py-5'>

        {/* Logo and Title */}
        <div className='text-center mb-4'>
          <img
            src={logonew}
            className='contact_logo img-fluid'
            alt="Bank Logo"
            style={{ maxWidth: '200px', cursor: 'pointer' }}
            onClick={() => navigate("/")}
          />
          <h4 className='mt-2'>Vilvattam Service Cooperative Bank Ltd No.337</h4>
          <p>Kurichikkara, Thrissur-28</p>
        </div>

        {/* Social Icons */}
        <div className='text-center mb-4 fs-4'>
          <FaWhatsapp style={{ color: "white", cursor: "pointer" }} onClick={handleWhatsappClick} />
          <FaInstagram className='ms-3' style={{ cursor: "pointer" }} onClick={handleInstagramClick} />
          <FaFacebook className='ms-3' style={{ cursor: "pointer" }} onClick={handlefbClick} />
        </div>

        {/* Main Info Sections */}
        <div className='row text-start'>

          {/* Contact Info */}
       <div className="col-12 col-md-6 col-lg-2 mb-4">
    <p>
      <BsTelephoneFill />{" "}
      <span className="class_point" onClick={handlePhoneClick} style={{ cursor: 'pointer' }}>
        0487-2695623, 2694717
      </span>
    </p>
    <p className="class_point" onClick={handleLocationClick} style={{ cursor: 'pointer' }}>
      <MdLocationPin /> &nbsp;Kurichikkara, Thrissur-28
    </p>
    <p className="class_point" onClick={handleEmailClick} style={{ cursor: 'pointer' }}>
      <MdEmail /> &nbsp;vilvattamscb337@gmail.com
    </p>
    <div className="mt-3">
      <strong>Our Branches:</strong>
      <ul className="mt-2">
        <li>Cheroor: 2332126</li>
        <li>Kuttumuck: 2320111</li>
        <li>Puthenvettuvazhy: 2321632</li>
        <li>Thanikkudam: 2695523</li>
      </ul>
    </div>
  </div>

  {/* Quick Links */}
  <div className="col-12 col-md-6 col-lg-2 mb-4">
    <p><strong>Quick Links</strong></p>
    <ul className="list-unstyled">
      <li className="class_point" onClick={() => navigate("/error")}>About</li>
      <li className="class_point" onClick={() => navigate("/error")}>Our Services</li>
      <li className="class_point" onClick={() => navigate("/error")}>Our Team</li>
    </ul>
  </div>

  {/* Our Offers */}
  <div className="col-12 col-md-6 col-lg-2 mb-4">
    <p><strong>Our Offers</strong></p>
    <ul className="list-unstyled">
      <li className="class_point" onClick={() => navigate("/error")}>Loans</li>
      <li className="class_point" onClick={() => navigate("/error")}>RTGS-NEFT</li>
      <li className="class_point" onClick={() => navigate("/error")}>Accounts</li>
      <li className="class_point" onClick={() => navigate("/error")}>Contact Us</li>
    </ul>
  </div>

  {/* Location Map */}
  <div className="col-12 col-md-6 col-lg-3 mb-4">
    <p><strong>Location</strong></p>
    <div className="ratio ratio-16x9" style={{ borderRadius: '10px', overflow: 'hidden' }}>
      <iframe
        title="Vilvattom Bank Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.666718334937!2d76.2241426!3d10.547221199999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7ef023887eaad%3A0x520a27c3fed27835!2sVilvattom%20Service%20Co-Operative%20Bank%20Ltd!5e0!3m2!1sen!2sin!4v1721101553756!5m2!1sen!2sin"
        width="100%"
        height="300"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </div>

  {/* Policies */}
  <div className="col-12 col-md-6 col-lg-3 mb-4">
    <p><strong>Policies</strong></p>
    <ul className="list-unstyled">
      <li className="class_point" onClick={() => navigate("/privacy")}>Privacy Policy</li>
      <li className="class_point" onClick={() => navigate("/refund")}>Refund & Cancellation</li>
      <li className="class_point" onClick={() => navigate("/terms")}>Terms & Conditions</li>
    </ul>
  </div>
</div>

        {/* Google Map Embed */}
        

        {/* Footer */}
        <div className="text-center mt-4">
          <p className="mb-0">© {new Date().getFullYear()} Vilvattam SCB Ltd. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
